export default __webpack_public_path__ + "static/media/Story3.15615237.svg";